// Outils partagés entre l'éditeur et les pages de lecture : sommaire, formules, liens internes
import katex from "katex";
import "katex/dist/katex.min.css"; // style des formules (pages de lecture et éditeur)
import { safeHtml } from "./sanitize";

/**
 * Sommaire d'un texte : liste des titres H2 (et H3 si includeH3), avec les libellés modifiés à la main
 * et les titres masqués. toc = { enabled, includeH3, items: { [idDuTitre]: { label?, hidden? } } }
 */
export function tocEntries(html, toc) {
  if (typeof document === "undefined" || !html) return [];
  const box = document.createElement("div");
  box.innerHTML = safeHtml(html);
  const levels = toc?.includeH3 ? "h2[id], h3[id]" : "h2[id]";
  return [...box.querySelectorAll(levels)].map((h) => {
    const custom = toc?.items?.[h.id] || {};
    return {
      id: h.id,
      level: h.tagName === "H3" ? 3 : 2,
      text: h.textContent.trim(),
      label: (custom.label || "").trim() || h.textContent.trim(),
      custom: !!(custom.label || "").trim(),
      hidden: !!custom.hidden,
    };
  });
}

/** Affiche les formules (blocs et formules dans le texte) avec KaTeX. */
export function renderMath(root) {
  if (!root) return;
  root.querySelectorAll('[data-type="block-math"], [data-type="inline-math"]').forEach((el) => {
    if (el.dataset.rendered) return;
    try {
      katex.render(el.getAttribute("data-latex") || "", el, {
        displayMode: el.getAttribute("data-type") === "block-math",
        throwOnError: false,
      });
      el.dataset.rendered = "1";
    } catch {
      /* formule invalide : laissée telle quelle */
    }
  });
}

/**
 * Liens internes (data-internal="course:id" ou "article:id") : adresse recalculée d'après le contenu actuel.
 * targets : { "course:id": "/cours/slug", "article:id": "/articles/slug" }
 */
export function applyInternalLinks(root, targets) {
  if (!root) return;
  root.querySelectorAll("a[data-internal]").forEach((a) => {
    const href = targets[a.getAttribute("data-internal")];
    if (href) a.setAttribute("href", href);
    a.removeAttribute("target");
    a.removeAttribute("rel");
  });
}
